/* eslint-disable no-case-declarations */

import {
  LOADING_DASHBOARD_INFO,
  LOADING_DASHBOARD_INFO_SUCCESS,
  LOADING_DASHBOARD_INFO_ERROR,
} from '../actions/dashboards';

const initialState = {
  dashboardInfo: {},
  loading: false,
};
  
const DashboardsReducer = (state = initialState, action) => {
    switch (action.type) {
      case LOADING_DASHBOARD_INFO:
        return { ...state, loading: true };
  
      case LOADING_DASHBOARD_INFO_SUCCESS:
        return {
          ...state,
          loading: false,
          dashboardInfo: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default DashboardsReducer;
  